"use strict";

exports.__esModule = true;
exports.XmlNode = void 0;
var _StringUtils = require("../Utils/StringUtils");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Represents an XML node.
 *
 * Encapsulates the data of an XML node: its attributes, inner text and children.
 */
var XmlNode = /*#__PURE__*/function () {
  function XmlNode(name, attributes) {
    /** @private */
    this.name = name;
    /** @private */
    this.attributes = attributes ? attributes : new Map();
    /** @private */
    this.text = "";
    /** @private */
    this.children = [];
  }
  XmlNode.attributeToString = function attributeToString(key, value) {
    return " " + key + "=\"" + value + "\"";
  }

  /**
   * Returns the attributes of this node
   * @return {Map} this node's attributes
   */;
  var _proto = XmlNode.prototype;
  _proto.getAttributes = function getAttributes() {
    return this.attributes;
  }

  /**
   * Returns the value of an attribute in this node
   * @param name the attribute name
   * @return {string} the attribute value
   */;
  _proto.getAttribute = function getAttribute(name) {
    return this.attributes.get(name);
  }

  /**
   * Returns an unmodifiable list of this node's children
   * @return {XmlNode[]} this node's children
   */;
  _proto.getChildren = function getChildren() {
    return this.children;
  }

  /**
   * Returns the inner text of this node or null if there is none
   * @return {string} this node's inner text
   */;
  _proto.getInnerText = function getInnerText() {
    return this.text;
  }

  /**
   * Returns the element name of this node
   * @return {string} this node's name
   */;
  _proto.getName = function getName() {
    return this.name;
  };
  _proto.addChild = function addChild(child) {
    this.children.push(child);
  };
  _proto.setInnerText = function setInnerText(text) {
    this.text = text;
  };
  _proto.toString = function toString() {
    // Create a start tag
    var s = "<";
    s += this.name;

    // Add any attributes
    for (var _iterator = _createForOfIteratorHelperLoose(this.attributes), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        key = _step$value[0],
        value = _step$value[1];
      s += XmlNode.attributeToString(key, value);
    }
    if (this.children.length === 0 && (0, _StringUtils.isNullOrEmpty)(this.text)) {
      // Close start tag
      s += "/>";
    } else {
      s += ">";
      if (!(0, _StringUtils.isNullOrEmpty)(this.text)) {
        s += this.text;
      }

      // Add any children
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.children), _step2; !(_step2 = _iterator2()).done;) {
        var c = _step2.value;
        s += (0, _StringUtils.toIndentedString)("\n" + c);
      }

      // Close tag on a newline only if the body isn't a simple tag
      if (!(0, _StringUtils.isNullOrEmpty)(this.text) && this.children.length === 0) {
        s += "</";
        s += this.name;
        s += ">";
      } else {
        s += (0, _StringUtils.toUnindentedString)("\n</" + this.name + ">");
      }
    }
    return s;
  };
  return XmlNode;
}();
exports.XmlNode = XmlNode;